import React from "react";
import { Card, Dropdown, Search } from "semantic-ui-react";
import "../../styles/ui.scss";

const BCCardMenuBar = ({ ...props }) => {
  const viewOptions = [
    { key: "Default", text: "Default", value: "Default" }
  ];
  return (
    <Card fluid className='card-menubar-container'>
      <div className="card-menubar">
        <div className="card-menubar-inline">
          {props.leftCustom}
        </div>
        <div className="card-menubar-inline">
          {props.rightCustom}
          {props.hasSearch && <Search
            open={false}
            onSearchChange={props.handleSearchChange}
            placeholder={props.searchPlaceholder ? props.searchPlaceholder : "Search table..."}
          />}
          {props.hasViewFilter && <div className="card-menubar-dropdown">
            <Dropdown
              button
              className="icon card-menubar-dropdown-text"
              floating
              labeled
              fluid
              icon='setting'
              options={viewOptions}
              selection
              defaultValue={viewOptions[0].value}
            />
          </div>}
        </div>
      </div>
    </Card>
  );
};

export default BCCardMenuBar;